import { FunctionComponent, useState } from 'react'
import styles from '../export.module.scss'
import { BrowserUpdated } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { ExportDataType } from '@/types/Export'
import { Daycare } from '@/types/Daycare'
import ExportDialog from '../exportDialog.tsx'

interface ExportParentsProps {
    daycares: Daycare[]
    isRpeOrLaep: boolean
}

const ExportParents: FunctionComponent<ExportParentsProps> = ({ daycares, isRpeOrLaep }: ExportParentsProps) => {
    const { t } = useTranslation()

    const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false)

    return (
        <>
            <a className={styles.Case} onClick={(): void => setIsDialogOpen(true)}>
                <p className={styles.CaseTitle}>{isRpeOrLaep ? t('publicList') : t('parentList')}</p>
                <BrowserUpdated className={styles.CaseIcon} />
            </a>
            {isDialogOpen && (
                <ExportDialog
                    type={ExportDataType.Parents}
                    open={isDialogOpen}
                    handleClose={(): void => setIsDialogOpen(false)}
                    daycares={daycares}
                    minDate={''}
                    isRpeOrLaep={isRpeOrLaep}
                />
            )}
        </>
    )
}

export default ExportParents
